import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { InvitationsStore } from '@store';

export interface Documents {
  href: string;
  revisionId: string;
  title: string;
}

@Injectable()
export class DataService {
  forceGetRequest = false;
  selectedInstallationId: number;
  invitationsCount$: Observable<number>;
  isNewInstaller$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private invitationsStore: InvitationsStore) {
    this.invitationsCount$ = invitationsStore.incomingCount$;
  }

  getInvitationsCount(): void {
    this.invitationsStore.getPendingInvitationsCount();
  }

  resetSubscriptions(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.ngUnsubscribe = new Subject<void>();
  }
}
